import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

import { Button, FormControl, ButtonGroup } from 'react-bootstrap'

import { Typeahead } from 'react-bootstrap-typeahead'

import {
  inputProjectLeads,
  inputAnalysts,
  changeDeliverableSortType,
  changeDeliverableAssignedToFilter,
  inputClients,
  changeDeliverableStatusFilter,
  clearAllDeliverableFilters,
  myDeliverablesSwitch,
  inputStatus,
  changeDeliverablesPage,
} from '../reducers/manageProjectFilters'


class DeliverablesFilter extends Component {

  componentDidMount() {
    this.resetDeliverablesPage()
  }

  componentDidUpdate(prevProps, nextProps) {
    this.resetDeliverablesPage()
  }

  resetDeliverablesPage = () => {
    /// THIS WILL TURN THE PAGE BACK TO 1 IF AFTER FILTERING THE PAGE
    /// OUTNUMBERS THE NUMBER OF FILTERED PROJECTS
    if (this.props.currentDeliverablesPage > 1 && this.props.deliverables.length === 0) {
      this.props.changeDeliverablesPage(1)
    }
  }

  _renderMenuItemChildren = (user, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
    return [
      <div key="name" search={props.text}>
        <strong>{user.first_name} {user.last_name}</strong>
      </div>,
      <div key="email">
        <small>
          Email: {user.email ? user.email : "N/A"}
        </small>
      </div>,
    ]
  }

  render () {

    const users = this.props.users

    const filteredClients = this.props.clients.filter(client => client.managed_by_genesis)

    return (
      <Fragment>
        <div>
          <center className="activity-tracker">
            <span style={{textDecoration: 'underline'}}>
              Deliverables
            </span>
            <br/>
            <span>
              On Going: {this.props.deliverableStatusCounts.onGoing}
            </span>
            <br/>
            <span>
              Past Due: {this.props.deliverableStatusCounts.pastDue}
            </span>
            <br/>
            <span>
              Not Started: {this.props.deliverableStatusCounts.notStarted}
            </span>
            <br/>
            <span>
              Completed: {this.props.deliverableStatusCounts.completed}
            </span>
          </center>
        </div>

        <hr/>

        <center>
          <h3>Filters</h3>
        </center>

        <center>
          <ButtonGroup className="my-project-filter-buttons">
            <Button
              active={this.props.myDeliverablesFilter}
              onClick={() => this.props.myDeliverablesSwitch(true)}
            >
              My Deliverables
            </Button>
            <Button
              active={!this.props.myDeliverablesFilter}
              onClick={() => this.props.myDeliverablesSwitch(false)}
            >
              All Deliverables
            </Button>
          </ButtonGroup>
        </center>

        {this.props.projectLeadFilter.length || this.props.analystFilter.length || this.props.clientFilter.length || this.props.deliverableAssignedToFilter.length || this.props.deliverableStatusFilter.length ?
          <center>
            <br/>
            <Button onClick={this.props.clearAllDeliverableFilters}>
              Clear All Filters
            </Button>
          </center>
          :
          null
        }

        <div>
          <h5>Sort Deliverables By</h5>
          <FormControl
            componentClass="select"
            placeholder="Sort Deliverables"
            onChange={(e) => this.props.changeDeliverableSortType(e.target.value)}
            value={this.props.deliverableSortType}
          >
            <option value="-due_date">Due Date (Descending)</option>
            <option value="due_date">Due Date (Ascending)</option>
            <option value="-created_date">Newest Deliverable</option>
            <option value="created_date">Oldest Deliverable</option>
            <option value="-project__created_date">Newest Project</option>
            <option value="project__created_date">Oldest Project</option>
            <option value="-modified_date">Most Recent Change</option>
            <option value="status">Status</option>
            <option value="project__number">Project Number</option>
          </FormControl>
        </div>

        <div>
          <h5>Client(s)</h5>
          <Typeahead
            id="ClientsFilterTypeahead"
            clearButton
            labelKey={client => `${client.name} ${client.short_code}`}
            multiple
            selected={this.props.clientFilter}
            options={filteredClients}
            placeholder="Client"
            onChange={this.props.inputClients}
            />
        </div>

        <div>
          <h5>Project Lead(s)</h5>
          <Typeahead
            id="ProjectLeadsFilterTypeahead"
            clearButton
            labelKey={user => `${user.first_name} ${user.last_name}`}
            multiple
            renderMenuItemChildren={this._renderMenuItemChildren}
            selected={this.props.projectLeadFilter}
            options={users}
            placeholder="Project Lead"
            onChange={this.props.inputProjectLeads}
            />
        </div>

        <div>
          <h5>Analyst(s)</h5>
          <Typeahead
            id="AnalystsFilterTypeahead"
            clearButton
            labelKey={user => `${user.first_name} ${user.last_name}`}
            multiple
            renderMenuItemChildren={this._renderMenuItemChildren}
            selected={this.props.analystFilter}
            options={users}
            placeholder="Analyst"
            onChange={this.props.inputAnalysts}
            />
        </div>

        <div>
          <h5>Project Status</h5>
          <Typeahead
            id="ProjectStatusFilterTypeahead"
            clearButton
            labelKey="name"
            multiple
            selected={this.props.projectStatusFilter}
            options={["Active", "On Hold", "Not Started", "Completed"]}
            placeholder="Status"
            onChange={this.props.inputStatus}
          />
        </div>

        <div>
          <h5>Deliverable Assigned To</h5>
          <Typeahead
            id="AssignedToFilterTypeahead"
            clearButton
            labelKey={user => `${user.first_name} ${user.last_name}`}
            multiple
            renderMenuItemChildren={this._renderMenuItemChildren}
            selected={this.props.deliverableAssignedToFilter}
            options={users}
            placeholder="Assigned To"
            onChange={this.props.changeDeliverableAssignedToFilter}
            />
        </div>

        <div>
          <h5>Deliverable Status</h5>
          <Typeahead
            id="DeliverableStatusFilterTypeahead"
            clearButton
            labelKey="name"
            multiple
            selected={this.props.deliverableStatusFilter}
            options={["On Going", "Past Due", "Not Started", "Completed"]}
            placeholder="Status"
            onChange={this.props.changeDeliverableStatusFilter}
          />
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.manageLogin.users,
    clients: state.manageLogin.clients,
    projectLeadFilter: state.manageProjectFilters.projectLeads,
    analystFilter: state.manageProjectFilters.analysts,
    clientFilter: state.manageProjectFilters.clients,
    deliverableStatusCounts: state.manageProjects.deliverableStatusCounts,
    myDeliverablesFilter: state.manageProjectFilters.myDeliverablesFilter,
    deliverableStatusFilter: state.manageProjectFilters.deliverableStatusFilter,
    deliverableAssignedToFilter: state.manageProjectFilters.deliverableAssignedToFilter,
    deliverableSearchTerm: state.manageProjectFilters.deliverableSearchTerm,
    deliverableSortType: state.manageProjectFilters.deliverableSortType,
    projectStatusFilter: state.manageProjectFilters.status,
    deliverables: state.manageProjects.deliverables,
  }
}

export default connect(mapStateToProps, { inputProjectLeads, inputAnalysts, changeDeliverableSortType, inputClients, clearAllDeliverableFilters, myDeliverablesSwitch, changeDeliverableAssignedToFilter, changeDeliverableStatusFilter, inputStatus, changeDeliverablesPage })(DeliverablesFilter);



// WEBPACK FOOTER //
// ./src/routes/projects/components/DeliverablesFilter.js